
import AddressLink from './AddressLink'

export default {
  extends: AddressLink,
  methods: {
    onClick() {
      this.$tracker.trackEvent('view_directions', {
        category: 'contact',
        label: 'navigation'
      })
    },
    geoLink(lat, lon) {
      return `https://www.google.com/maps/dir//${lat},${lon}`
    },
    addressLink(address) {
      const search = address.replace(/\s/g, '+')
      return `https://www.google.com/maps/dir//${search}`
    }
  }
}
